<template>
  <div class="relative mt-28">
    <strapi-image
      class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
      :image="component.customComponent.backgroundImage"
      as-background
      :ignore-overlay="true"
    />

    <div class="relative z-10 max-w-screen-xl mx-auto px-4 py-12">
      <h1 class="mb-8 text-center uppercase">
        {{ component.customComponent.title }}
      </h1>
      <p class="mb-12 text-xl font-bold text-center">
        {{ component.customComponent.content }}
      </p>
      <div class="flex flex-wrap justify-center gap-16">
        <strapi-button
          v-for="link in component.customComponent.buttons"
          :key="link.id"
          :component="link"
          :force-image-height="64"
          :force-image-width="64"
          :image-classes="'mx-auto block'"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { StrapiCustomComponent } from '../../../apollo/types/types';

export default defineComponent({
  props: {
    component: {
      type: Object as PropType<StrapiCustomComponent>,
      required: true,
    },
  },
});
</script>
